<div class="gray-container" appLayout>
    <router-outlet></router-outlet>
</div>
